import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import PageNotfound from '../../../../assets/page_not_found.svg';
import useScreenSize from '../../../../utils/useScreenSize';

const ErrorConfirmationPage: React.FC = () => {
  const { t } = useTranslation();
  const { isXsScreen  } = useScreenSize();
    
  return (
    <Box 
      data-testid='error-confirmation-page'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingY: spaces.xxxxxl,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: isXsScreen ? 'auto': '600px',
          paddingX: isXsScreen ? 0 : spaces.xxxxl,
        }}
      >
        <Box
          sx={{
            paddingTop: spaces.xxl,
            paddingBottom: spaces.xxxxxl,
            paddingX: spaces.xxxl,
            '& svg': {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            },
          }}
        >
          <PageNotfound />
        </Box>   
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: spaces.lg,
          }}
        >
          <Typography
            variant='h4'
            sx={{
              color: palette.text.primary,
              textAlign: 'center',
            }}
          >
            {t('Something went wrong')}
          </Typography>
          <Typography
            variant='body1'
            sx={{
              color: palette.text.secondary,
              textAlign: 'center',
            }}
          >
            {t('You\'ve already confirmed your email address, or your link is unfortunately no longer valid.' +
              ' In this case, we\'ve sent you an email with a new confirmation link.')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default ErrorConfirmationPage;

